import { render, staticRenderFns } from "./ReportingProfileDetails.vue?vue&type=template&id=01349bc8&"
import script from "./ReportingProfileDetails.vue?vue&type=script&lang=js&"
export * from "./ReportingProfileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports